import { useCallback, useState } from "react";
import { userReportsApi } from "../api";
import type { PreviewResult } from "../api";
import { getApiErrorMessage } from "../utils";

export function useReportPreview(reportId: string) {
  const [preview, setPreview] = useState<PreviewResult | null>(null);
  const [previewLoading, setPreviewLoading] = useState(false);
  const [previewOpen, setPreviewOpen] = useState(false);

  const togglePreview = useCallback(async () => {
    if (previewOpen) {
      setPreviewOpen(false);
      return;
    }

    setPreviewLoading(true);
    try {
      const response = await userReportsApi.preview(reportId);
      setPreview(response.data);
    } catch (caught) {
      setPreview({
        row_count: 0,
        rows: [],
        error: getApiErrorMessage(caught, "Could not preview this report"),
      });
    } finally {
      setPreviewOpen(true);
      setPreviewLoading(false);
    }
  }, [previewOpen, reportId]);

  return { preview, previewLoading, previewOpen, togglePreview };
}
